class ProductMatchingRows extends HTMLElement {
  constructor() {
    super();
    this.rows = this.querySelectorAll('.matching-row');
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.init();
  }

  init() {
    this.rows.forEach(row => {
      this.setupRow(row);
      const select = row.querySelector('.matching-row__select');
      let initialOption = select.querySelector('option[selected="selected"]');
      if (!initialOption) {
        initialOption = select.options[select.selectedIndex];
      }
      this.updateRowUI(row, initialOption);
      
      // Initialize custom select with first option
      const customSelect = row.querySelector('.custom-select');
      const triggerSpan = row.querySelector('.custom-select__trigger span');
      const customOptions = row.querySelectorAll('.custom-option');
      
      if (customOptions.length > 0) {
        // Set first option as selected
        customOptions[0].classList.add('selected');
        // Update trigger text to show first option
        triggerSpan.textContent = customOptions[0].textContent;
      }
    });
    this.initShowMore();
    
    // Add single global click listener instead of one per row
    document.addEventListener('click', this.handleOutsideClick);
  }

  // Handle clicks outside custom selects
  handleOutsideClick(e) {
    this.querySelectorAll('.custom-select').forEach(customSelect => {
      if (!customSelect.contains(e.target)) {
        customSelect.classList.remove('open');
      }
    });
  }

  // Cleanup when element is removed
  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  updateRowUI(row, selectedOption) {
    const image = row.querySelector('.matching-row__image img');
    const price = row.querySelector('.matching-row__price');
    const hiddenId = row.querySelector('input[name="id"]');
    const addBtn = row.querySelector('[data-add-to-cart]');
    const select = row.querySelector('.matching-row__select');


    const newImage = selectedOption.dataset.image;
    const newPrice = parseFloat(selectedOption.dataset.price);
    const newVariantId = selectedOption.value;
    const inventory = parseInt(selectedOption.dataset.inventory, 10);
    const continueSelling = selectedOption.dataset.continueSelling === 'true' || selectedOption.dataset.inventoryPolicy === 'continue';

    // Update details link to current selected variant's product
    const detailsLink = row.querySelector('.matching-row__details');
    const productUrl = selectedOption.dataset.productUrl;
    const productHandle = selectedOption.dataset.productHandle;
    if (detailsLink) {
      if (productUrl) detailsLink.href = productUrl;
      if (productHandle) detailsLink.dataset.handle = productHandle;
    }

    // Update image with proper srcset handling
    if (newImage && newImage.trim() !== '') {
      image.src = newImage;
      const img100 = selectedOption.dataset.image100;
      const img200 = selectedOption.dataset.image200;
      
      if (img100 && img200 && img100.trim() !== '' && img200.trim() !== '') {
        image.srcset = `${img100} 100w, ${img200} 200w`;
        image.sizes = '100px';
      } else {
        // Remove srcset if no responsive images available
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
    } else {
      // No image available, try to find and use placeholder
      const placeholderImg = document.querySelector('img[src*="blank.svg"]');
      if (placeholderImg) {
        image.src = placeholderImg.src;
      }
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }
    if (!isNaN(newPrice)) {
      const formattedPrice = (window.theme && theme.settings && theme.settings.currency_code_enable)
        ? window.theme.formatMoney(newPrice, theme.moneyWithCurrencyFormat)
        : window.theme.formatMoney(newPrice, theme.moneyFormat);
      price.innerHTML = formattedPrice;
    }
    if (newVariantId) {
      hiddenId.value = newVariantId;
    }
    const available = (inventory > 0) || continueSelling;
    addBtn.disabled = !available;
  }

  initShowMore() {
    const showMoreContainer = this.querySelector('#show-more-container');
    const showLessContainer = this.querySelector('#show-less-container');
    const showMoreBtn = this.querySelector('#show-more-btn');
    const showLessBtn = this.querySelector('#show-less-btn');
    const rows = this.querySelectorAll('.matching-row');

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', () => {
        rows.forEach(row => row.classList.remove('hidden'));
        showMoreContainer.classList.add('hidden');
        if (showLessContainer) {
          showLessContainer.classList.remove('hidden');
        }
      });
    }

    if (showLessBtn) {
      showLessBtn.addEventListener('click', () => {
        rows.forEach((row, index) => {
          if (index >= 4) {
            row.classList.add('hidden');
          }
        });
        showLessContainer.classList.add('hidden');
        if (showMoreContainer) {
          showMoreContainer.classList.remove('hidden');
        }
      });
    }
  }

  setupRow(row) {
    const select = row.querySelector('.matching-row__select');
    select.addEventListener('change', (event) => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      this.updateRowUI(row, selectedOption);
    });

    const customSelect = row.querySelector('.custom-select');
    const trigger = row.querySelector('.custom-select__trigger');
    const customOptions = row.querySelectorAll('.custom-option');

    trigger.addEventListener('click', () => {
      customSelect.classList.toggle('open');
    });

    customOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        const value = option.dataset.value;
        const text = option.textContent;
        
        // Remove selected class from all options
        customOptions.forEach(opt => opt.classList.remove('selected'));
        // Add selected class to clicked option
        option.classList.add('selected');
        
        // Update hidden select
        select.value = value;
        select.dispatchEvent(new Event('change'));
        
        // Update custom trigger text
        trigger.querySelector('span').textContent = text;
        
        // Close dropdown
        customSelect.classList.remove('open');
      });
    });
  }
}

if (!customElements.get('product-matching-rows')) {
  customElements.define('product-matching-rows', ProductMatchingRows);
}